module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtext1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("‘The world is your studio. Never let anything remain unsketched.’")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "fmtext1a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Adebanji Alade")])]), _vm._v(" "), _c('div', {
    staticClass: "tspace"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-001.jpg"
    }
  })])])]), _c('div', {
    staticClass: "pbreak"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('div', {
    staticClass: "tspace"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fmauth"
  }, [_c('span', {
    staticClass: "ornb"
  }, [_vm._v("ADEBANJI ALADE,")]), _vm._v(" otherwise known as ‘The Addictive Sketcher’, features regularly on the BBC’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The One Show")]), _vm._v(", and can often be found sketching travellers on the London Underground.")]), _vm._v(" "), _c('p', {
    staticClass: "fmtext-in"
  }, [_vm._v("He trained at Yaba College of Technology in Nigeria, later obtaining a diploma in portraiture from Heatherley’s School of Fine Art in Chelsea, where he now teaches. Adebanji is the vice president of the Royal Institute of Oil Painters; a full member of The Guild of Fine Art in Nigeria; and in 2014 was elected to the council of the Chelsea Art Society. He also belongs to Urban Sketchers Worldwide and Plein Air Brotherhood.")]), _vm._v(" "), _c('p', {
    staticClass: "fmtext-in"
  }, [_vm._v("His awards include Buxton Spa Sketchbook Award (2014); winner of Pinta Rapido Plein Air Event at Chelsea Town Hall in 2013; winner of Best Painting of a London Scene, Chelsea Art Society in 2010; the Alan Gourley Memorial Award at the Royal Institute of Oil Painters Exhibition 2017, and numerous others.")]), _vm._v(" "), _c('p', {
    staticClass: "fmtext-in"
  }, [_vm._v("Adebanji has a strong following in the US as well as the UK. He writes regularly for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Artist")]), _vm._v(" magazine and exhibits with the Royal Institute of Oil Painters. He teaches at the Art Academy, London, and also runs workshops and demos for schools, colleges, universities and art societies.")]), _vm._v(" "), _c('p', {
    staticClass: "fmtext-in"
  }, [_vm._v("Follow Adebanji online:")])]), _c('p', {
    staticClass: "fmtext"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Website: ")]), _c('a', {
    attrs: {
      "href": "http://www.adebanjialade.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.adebanjialade.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtext"
  }, [_vm._v("instagram: @addictivesketcher")]), _vm._v(" "), _c('p', {
    staticClass: "fmtext"
  }, [_vm._v("Facebook page: "), _c('a', {
    attrs: {
      "href": "http://facebook.com/addictivesketcher",
      "target": "_blank"
    }
  }, [_vm._v("facebook.com/addictivesketcher")])]), _vm._v(" "), _c('div', {
    staticClass: "pbreak"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-003.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6857633b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Author.vue
// module id = 57
// module chunks = 0